<template>
  <div class="bottom-box">
    <div class="left-title d-aligncnter">
      <img
        class="img-24"
        style="margin-right: 4px; width: 24px; height: 24px"
        src="@/assets/img/cockpit/calendar.svg"
      />近2周参测人数统计
    </div>
    <div class="echarts">
      <div
        id="dayly"
        :style="{
          width: '2240px',
          height: '200px',
          margin: '0 auto',
        }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['testDayly', 'testDaylyDate'],
  data() {
    return {
      echartsData: '',
      option1: {},
    }
  },
  watch: {
    testDayly: {
      handler: function (newVal) {
        this.option1.series[0].data = newVal
        this.option1.xAxis.data = this.testDaylyDate
        var myChart1 = this.$echarts.init(document.getElementById('dayly'))
        myChart1.setOption(this.option1)
      },
      deep: true,
    },
  },
  created() {
    setTimeout(() => {
      var myChart1 = this.$echarts.init(document.getElementById('dayly'))
      myChart1.setOption(this.option1)
    }, 6000)
  },
  mounted() {
    this.drawMonthData(this.testDayly)
    window.onresize = () => {
      return (() => {
        this.drawMonthData(this.testDayly)
      })()
    }
  },
  computed: {},
  methods: {
    drawMonthData(data) {
      var myChart1 = this.$echarts.init(document.getElementById('dayly'))
      this.option1 = {
        tooltip: {},
        xAxis: {
          type: 'category',
          boundaryGap: true,
          //   axisLabel: { interval: 0, rotate: 30 },
          data: this.testDaylyDate,
          axisTick: {
            alignWithLabel: true,
          },
        },
        axisLabel: {
          color: '#339571',
        },
        yAxis: {
          minInterval: 20,
          axisLine: {
            show: true, //是否显示轴线
            lineStyle: {
              color: '#339571', //刻度线的颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: '#339571',
            },
          },
        },
        series: [
          {
            name: '时间',
            type: 'bar',
            areaStyle: {},
            data: data,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFB612' },
                { offset: 1, color: '#4DA282' },
              ]),
            },
          },
        ],
      }
      myChart1.setOption(this.option1)
    },
  },
}
</script>
<style scoped lang="scss">
.bottom-box {
  height: 148px;
  width: 1856px;
  font-size: 20px;
  background: linear-gradient(
    0deg,
    rgba(0, 122, 77, 0.1) 80%,
    rgba(0, 122, 77, 0.1) 100%
  );
  padding: 16px 16px 0 16px;
  margin-left: 16px;
}
.left-box {
  width: calc(100% - 0px);

  margin-top: 16px;

  .left-title {
    font-size: 20px;
    margin-bottom: 8px;
    margin-left: 24px;
  }
}
.left-title {
  margin-left: 24px;
}
.echarts {
  //   width: calc(100% - 48px);
  //   background: linear-gradient(
  //     180deg,
  //     rgba(26, 135, 95, 0.15) 0%,
  //     rgba(0, 122, 77, 0.24) 100%
  //   );
  margin-left: -190px;
  //   height: calc(26vh - 46px);
  margin-top: -44px;
}
</style>
